// extracted by mini-css-extract-plugin
export default {"stackCards":"dashboard_stackCards__G-wJS","stackCardsItem":"dashboard_stackCardsItem__7fkFV","invertedBorderRadius":"dashboard_invertedBorderRadius__4Q66F"};